import "App.scss"
import { useState, useEffect, useCallback, useContext } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  makeStyles,
  Box,
  Typography,
  Paper,
  Divider,
  Card,
  CardContent,
} from "@mui/material"
import { Footer } from "components/Footer"

import { BigButton } from "components/BigButton"
import { SuperStyledTextField } from "components/SuperStyledTextField"
import { CardRowSmall } from "components/CardRowSmall"
// import orderImg from "images/Cafe_Cafe_Logo.png"
import { useNavigator } from "hooks/useNavigator"
import { CartContext } from "App"

import { useTranslation } from "react-i18next"
import i18n from "helpers/i18n"
import { FlexRowContainer, StyledSelect } from "components/AllHelpComponents"
import { fixScrollTop } from "helpers/scrollSaver"

const styles = {
  overflow: "hidden",
  overflowWrap: "break-word",
  height: "46px",
}

export function OrderPage() {
  const tele = window.Telegram.WebApp
  const { t } = useTranslation()
  const { env } = useNavigator()

  const {
    telephone,
    setTelephone,
    address,
    setAddress,
    cartItems,
    settings,
    foods,
    comment,
    setComment,
    customerName,
    setCustomerName,
    totalPrice,
    setTotalPrice,
    optionDelivery,
    setOptionDelivery,
  } = useContext(CartContext)

  const handleChange = (event) => {
    setComment(event.target.value)
  }

  const handleCustomerNameChange = (event) => {
    setCustomerName(event.target.value)
  }

  const navigate = useNavigate()

  const [addressError, setAddressError] = useState(false)
  const [telephoneError, setTelephoneError] = useState(false)

  const onSubmit = useCallback(() => {
    // Проверка обязательных полей для delivery
    if (optionDelivery === "delivery") {
      let hasError = false

      // Валидация адреса (минимум 5 символов)
      if (!address || address.trim() === "") {
        setAddressError(true)
        hasError = true
      } else if (address.trim().length < 5) {
        setAddressError(true)
        hasError = true
      } else {
        setAddressError(false)
      }

      // Валидация телефона (минимум 10 цифр)
      if (!telephone || telephone.trim() === "") {
        setTelephoneError(true)
        hasError = true
      } else {
        const digitsOnly = telephone.replace(/\D/g, "")
        if (digitsOnly.length < 10) {
          setTelephoneError(true)
          hasError = true
        } else {
          setTelephoneError(false)
        }
      }

      if (hasError) {
        return
      }
    }

    navigate("/payments")
  }, [cartItems, comment, customerName, optionDelivery, address, telephone])

  const onBack = () => {
    navigate(-1)
    // navigate("/products")
  }

  const onChangeAddress = (e) => {
    setAddress(e.target.value)
    if (addressError) {
      setAddressError(false)
    }
  }
  const onChangeTelephone = (e) => {
    setTelephone(e.target.value)
    if (telephoneError) {
      setTelephoneError(false)
    }
  }

  const onChangeOption = (e) => {
    setOptionDelivery(e.target.value)
    // Сбрасываем ошибки при изменении типа доставки
    setAddressError(false)
    setTelephoneError(false)
  }

  // useEffect(() => {
  //   window.scrollTo({
  //     top: document.body.scrollHeight,
  //     behavior: "smooth",
  //   })
  // }, [optionDelivery])

  useEffect(() => {
    fixScrollTop()
  }, [])

  const currentTimestamp = Math.floor(Date.now() / 1000)

  function calculateTotalPrice(products, order) {
    let totalPrice = 0

    for (const item of order) {
      const product = products.find((p) => p.id === item.id)
      if (product) {
        totalPrice += product.price * item.quantity

        if (item?.selectedToppings) {
          for (const topping of item.selectedToppings) {
            const toppingData = product.toppings.find((t) => t.title === topping)
            if (toppingData) {
              totalPrice += toppingData.price * item.quantity
            }
          }
        }

        if (item?.selectedChoices?.length) {
          item?.selectedChoices.forEach((choice) => {
            choice.options.forEach((option) => {
              totalPrice += option.price || 0
            })
          })
        }

        if (item?.selectedAddons?.length) {
          item?.selectedAddons.forEach((addon) => {
            addon.options.forEach((option) => {
              totalPrice += option.price || 0
            })
          })
        }
      }
    }

    return totalPrice
  }

  useEffect(() => {
    console.log("foods :>> ", foods)
    setTotalPrice(calculateTotalPrice(foods, cartItems))
  }, [foods, cartItems, setTotalPrice])

  return (
    <>
      <Box sx={{ maxWidth: "100%", margin: "0 auto", p: 2 }}>
        {/* Заголовок страницы */}
        <Typography
          variant="h4"
          align="center"
          sx={{
            mb: 3,
            fontWeight: "bold",
            color: "#f4f5f5",
            letterSpacing: 0.5
          }}
        >
          {t("Order")}
        </Typography>

        {/* Информация о заказе с логотипом */}
        <Paper
          elevation={0}
          sx={{
            mb: 2,
            p: 2.5,
            background: "#1a222c",
            border: "1px solid #2e30adff",
            borderRadius: "8px"
          }}
        >
          {settings?.logoImage && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
                width: "100%",
                maxHeight: "120px",
                mb: 2,
                borderRadius: "6px"
              }}
            >
              <Box
                component="img"
                src={settings?.logoImage}
                alt="Restaurant Logo"
                sx={{
                  maxWidth: "100%",
                  maxHeight: "120px",
                  objectFit: "contain",
                }}
              />
            </Box>
          )}

          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="h6"
              fontWeight="600"
              sx={{
                color: "#f4f5f5",
                mb: 0.5
              }}
            >
              {t("Order")} № {currentTimestamp}
            </Typography>
            {settings?.textToOrder && (
              <Typography
                variant="body2"
                sx={{
                  color: "#b1bfcf",
                  fontSize: "0.9rem"
                }}
              >
                {settings?.textToOrder}
              </Typography>
            )}
          </Box>
        </Paper>

        {/* Список товаров в заказе */}
        {cartItems && cartItems.length > 0 && (
          <Paper
            elevation={0}
            sx={{
              mb: 2,
              background: "#1a222c",
              border: "1px solid #2e30adff",
              borderRadius: "8px",
              overflow: "hidden"
            }}
          >
            <Box sx={{
              py: 1.5,
              px: 2,
              backgroundColor: "#1a222c",
              borderBottom: "1px solid #2e30adff"
            }}>
              <Typography
                variant="subtitle1"
                fontWeight="600"
                sx={{ color: "#f4f5f5" }}
              >
                {t("Your Items")}
              </Typography>
            </Box>
            <Box sx={{ p: 1 }}>
              {cartItems.map((food) => {
                return <CardRowSmall food={food} key={food.id} />
              })}
            </Box>
          </Paper>
        )}

        {/* Итоговая цена */}
        <Paper
          elevation={0}
          sx={{
            mb: 2,
            p: 2.5,
            background: "#1a222c",
            border: "2px solid #2e30adff",
            borderRadius: "8px"
          }}
        >
          <FlexRowContainer sx={{ justifyContent: "space-between", alignItems: "center" }}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ color: "#f4f5f5" }}
            >
              {t("Total Price:")}
            </Typography>
            {console.log("totalPrice >> ", totalPrice)}
            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{ color: "#5cb8ffff" }}
            >
              {totalPrice?.toFixed(2)}{settings?.currency?.symbol ? ' ' + settings.currency.symbol : ''}
            </Typography>
          </FlexRowContainer>
        </Paper>
      </Box>

      {/* Поле ввода имени */}
      <Paper
        elevation={0}
        sx={{
          mb: 2,
          mx: 2,
          background: "#1a222c",
          border: "1px solid #2e30adff",
          borderRadius: "8px",
          overflow: "hidden"
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography
            variant="subtitle2"
            fontWeight="600"
            sx={{ color: "#f4f5f5", mb: 1.5 }}
          >
            {t("Your Name :")}
          </Typography>
          <TextField
            fullWidth
            placeholder={t("Add name")}
            value={customerName}
            onChange={handleCustomerNameChange}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                color: "#f4f5f5",
                backgroundColor: "#131415",
                borderRadius: "6px",
                "& fieldset": {
                  borderColor: "#b1bfcf",
                },
                "&:hover fieldset": {
                  borderColor: "#5cb8ffff",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#5cb8ffff",
                  borderWidth: "1px",
                },
              },
              "& .MuiInputBase-input": {
                padding: "10px 14px",
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#b1bfcf",
                opacity: 0.7,
              },
            }}
          />
        </Box>
      </Paper>

      {/* Поле ввода комментария */}
      <Paper
        elevation={0}
        sx={{
          mb: 2,
          mx: 2,
          background: "#1a222c",
          border: "1px solid #2e30adff",
          borderRadius: "8px",
          overflow: "hidden"
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography
            variant="subtitle2"
            fontWeight="600"
            sx={{ color: "#f4f5f5", mb: 1.5 }}
          >
            {t("Your Comment :")}
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={3}
            placeholder={t("Add comment")}
            value={comment}
            onChange={handleChange}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                color: "#f4f5f5",
                backgroundColor: "#131415",
                borderRadius: "6px",
                "& fieldset": {
                  borderColor: "#b1bfcf",
                },
                "&:hover fieldset": {
                  borderColor: "#5cb8ffff",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#5cb8ffff",
                  borderWidth: "1px",
                },
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#b1bfcf",
                opacity: 0.7,
              },
            }}
          />
          <Typography
            variant="caption"
            sx={{
              color: "#b1bfcf",
              mt: 1,
              display: "block",
              fontSize: "0.75rem"
            }}
          >
            {t("Any special requests, details, final wishes etc.")}
          </Typography>
        </Box>
      </Paper>

      {(settings?.showOnSiteOption ||
        settings?.showTakeAwayOption ||
        settings?.showDeliveryOption) && (
        <Paper
          elevation={0}
          sx={{
            mb: 2,
            mx: 2,
            pb: "120px",
            background: "#1a222c",
            border: "1px solid #2e30adff",
            borderRadius: "8px",
            overflow: "hidden"
          }}
        >
          <Box sx={{
            py: 1.5,
            px: 2,
            backgroundColor: "#1a222c",
            borderBottom: "1px solid #2e30adff"
          }}>
            <Typography
              variant="subtitle1"
              fontWeight="600"
              sx={{ color: "#f4f5f5" }}
            >
              {t("Choose where you eat")}
            </Typography>
          </Box>

          <Box sx={{ p: 2 }}>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <Select
                value={optionDelivery}
                onChange={onChangeOption}
                sx={{
                  color: "#f4f5f5",
                  backgroundColor: "#131415",
                  borderRadius: "6px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#b1bfcf",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#5cb8ffff",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#5cb8ffff",
                    borderWidth: "1px",
                  },
                  "& .MuiSvgIcon-root": {
                    color: "#5cb8ffff",
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      bgcolor: "#1a222c",
                      border: "1px solid #2e30adff",
                      "& .MuiMenuItem-root": {
                        color: "#f4f5f5",
                        "&:hover": {
                          backgroundColor: "#131415",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#131415",
                          borderLeft: "3px solid #5cb8ffff",
                          "&:hover": {
                            backgroundColor: "#131415",
                          },
                        },
                      },
                    },
                  },
                }}
              >
                {settings?.showOnSiteOption && (
                  <MenuItem value="on_site">{t("On Site")}</MenuItem>
                )}
                {settings?.showTakeAwayOption && (
                  <MenuItem value="take_away">{t("Take Away")}</MenuItem>
                )}
                {settings?.showDeliveryOption && (
                  <MenuItem value="delivery">{t("Delivery")}</MenuItem>
                )}
              </Select>
            </FormControl>

            {optionDelivery === "delivery" && (
              <Box>
                <Box sx={{ mb: 2 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{ color: "#f4f5f5", mb: 1, fontWeight: 600 }}
                  >
                    {t("Address")} <span style={{ color: "#ff4444" }}>*</span>
                  </Typography>
                  <TextField
                    fullWidth
                    required
                    placeholder={t("Enter address")}
                    value={address}
                    onChange={onChangeAddress}
                    variant="outlined"
                    error={addressError}
                    helperText={
                      addressError
                        ? address.trim().length === 0
                          ? t("Address is required for delivery")
                          : t("Address must be at least 5 characters")
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        color: "#f4f5f5",
                        backgroundColor: "#131415",
                        borderRadius: "6px",
                        "& fieldset": {
                          borderColor: addressError ? "#ff4444" : "#b1bfcf",
                        },
                        "&:hover fieldset": {
                          borderColor: addressError ? "#ff4444" : "#5cb8ffff",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: addressError ? "#ff4444" : "#5cb8ffff",
                          borderWidth: "1px",
                        },
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "#b1bfcf",
                        opacity: 0.7,
                      },
                      "& .MuiFormHelperText-root": {
                        color: "#ff4444",
                      },
                    }}
                  />
                </Box>
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{ color: "#f4f5f5", mb: 1, fontWeight: 600 }}
                  >
                    {t("Telephone")} <span style={{ color: "#ff4444" }}>*</span>
                  </Typography>
                  <TextField
                    fullWidth
                    required
                    placeholder={t("Enter Telephone")}
                    value={telephone}
                    onChange={onChangeTelephone}
                    variant="outlined"
                    error={telephoneError}
                    helperText={
                      telephoneError
                        ? telephone.trim().length === 0
                          ? t("Telephone is required for delivery")
                          : t("Telephone must contain at least 10 digits")
                        : ""
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        color: "#f4f5f5",
                        backgroundColor: "#131415",
                        borderRadius: "6px",
                        "& fieldset": {
                          borderColor: telephoneError ? "#ff4444" : "#b1bfcf",
                        },
                        "&:hover fieldset": {
                          borderColor: telephoneError ? "#ff4444" : "#5cb8ffff",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: telephoneError ? "#ff4444" : "#5cb8ffff",
                          borderWidth: "1px",
                        },
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "#b1bfcf",
                        opacity: 0.7,
                      },
                      "& .MuiFormHelperText-root": {
                        color: "#ff4444",
                      },
                    }}
                  />
                </Box>
              </Box>
            )}
          </Box>
        </Paper>
      )}

      {env == "browser" && (
        <Footer>
          <FlexRowContainer>
            <BigButton onClick={onBack}>{`${t("Back")}  `}</BigButton>
            <BigButton onClick={onSubmit}>{`${t("Buy")} ${totalPrice}${settings?.currency?.symbol ? ' ' + settings.currency.symbol : ''}`}</BigButton>
          </FlexRowContainer>
        </Footer>
      )}
    </>
  )
}
